export type SubObjectType =
  | 'boolean'
  | 'float'
  | 'matchedMeta'
  | 'matchedUserAudit'
  | 'string';

export interface SubObjectTypes {
  [name: string]: SubObjectType;
}

export const matchedItem: SubObjectTypes = {
  active: 'boolean',
  expires: 'float',
  id: 'string',
  listId: 'string',
  meta: 'matchedMeta',
  target: 'string',
  value: 'string',
  when: 'float',
};

export const matchedUserAudit: SubObjectTypes = {
  username: 'string',
  when: 'float',
};

export const matchedMeta: SubObjectTypes = {
  created: 'matchedUserAudit',
  description: 'string',
  updated: 'matchedUserAudit',
};
